module.exports = function(service) {
	'use strict'
	service.factory('keyPress', keyPress);
	keyPress.$inject = [];
	function keyPress() {
	   return function(evt,star) {
			evt = (evt) ? evt : event;
		    var charCode = (evt.charCode) ? evt.charCode : ((evt.keyCode) ? evt.keyCode :
		    ((evt.which) ? evt.which : 0));
		    if(star) {
			    if (charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode != 45 && charCode != 42 && charCode != 269 && charCode != 263 && charCode != 382 && charCode != 353 && charCode != 273 && charCode != 268 && charCode != 262 && charCode != 381 && charCode != 352 && charCode != 272) {
			        evt.preventDefault();
			    }
		    } else {
		      	if (charCode > 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode != 269 && charCode != 263 && charCode != 382 && charCode != 353 && charCode != 273 && charCode != 268 && charCode != 262 && charCode != 381 && charCode != 352 && charCode != 272 && charCode !=95) {
			        evt.preventDefault();
			    }
		    }
	   }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/keyPressService.js
// module id = 615
// module chunks = 0